var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon ionic-ios-mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2942",
    d: "M9.77414 1.2869L7.29039 3.81682C7.27192 3.83529 7.27192 3.86299 7.29039 3.88146L9.02855 5.73273C9.14628 5.85046 9.14628 6.03974 9.02855 6.15746C8.97084 6.21517 8.89236 6.24518 8.81619 6.24518C8.74001 6.24518 8.66153 6.21517 8.60382 6.15746L6.87258 4.31311C6.85411 4.29465 6.8241 4.29465 6.80564 4.31311L6.38321 4.74246C6.03004 5.10025 5.56145 5.29877 5.05824 5.30108C4.5481 5.30338 4.06335 5.08871 3.70556 4.7263L3.29929 4.31311C3.28083 4.29465 3.25082 4.29465 3.23235 4.31311L1.50111 6.15746C1.4434 6.21517 1.36492 6.24518 1.28874 6.24518C1.21257 6.24518 1.13409 6.21517 1.07638 6.15746C0.958654 6.03974 0.958654 5.85046 1.07638 5.73273L2.81455 3.88146C2.8307 3.86299 2.8307 3.83529 2.81455 3.81682L0.328483 1.2869C0.298475 1.25689 0.25 1.27767 0.25 1.31922V6.38137C0.25 6.78764 0.582398 7.12003 0.988663 7.12003H9.11396C9.52023 7.12003 9.85262 6.78764 9.85262 6.38137V1.31922C9.85262 1.27767 9.80184 1.2592 9.77414 1.2869Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2943",
    d: "M5.0513 4.69871C5.39293 4.69871 5.71379 4.56483 5.95386 4.32014L9.57562 0.633751C9.44866 0.532184 9.29169 0.472168 9.11857 0.472168H0.986345C0.813221 0.472168 0.653947 0.532184 0.529297 0.633751L4.15106 4.32014C4.38881 4.56252 4.70967 4.69871 5.0513 4.69871Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.bd9dbf3b91d2d62063a2c95864a607b3.svg";
export { ForwardRef as ReactComponent };